import { Inquiry } from 'Molecules/';
import { Header } from 'Atoms/';

const Index = () => {
  return (
    <>
      <Header isInquiry={false} />
      <Inquiry />
    </>
  );
};
export default Index;
